<template>
	<div>

		<div  class="navigation-wrapper">

			<i class="close_overlay_container left lnr icon-cross" @click="$emit('hide_navigation')" v-if="show_close_button"></i>

			<nav>
				<ul class="root">
					<list_item
						v-for="item in structure"
						:item_data="item"
						:level="0"
					></list_item>
				</ul>
			</nav>
		</div>

		<div class="navigation-background" @click="$emit('hide_navigation')"></div>

	</div>

</template>

<script>
import list_item from '@/Components/Navigation/ListItem.vue';

export default {
	name: "Navigation",
	components : {
		list_item
	},
	props : [
		'structure',
		'show_close_button',
		'show_navigation_background'
	],

	emits : ['hide_navigation']
}
</script>

<style scoped>

</style>